import React, {useEffect, useState} from 'react';
import {hooks} from 'lib.front';
import {
   getCuentasMaxLimitesGql,
   getDatabasesAppListGql,
   getNanagerInstanciasGql
} from '../../utils/gql/gestionarAppsDbsGql';
import {useDispatch} from 'react-redux';
import {Aplicacion} from '../../bussines/entities/Aplicacion';
import {ProcesarDatabasesInfoUseCase} from '../../bussines/useCases/ProcesarDatabasesInfoUseCase';
import {CuentaMaxLimites} from '../../bussines/entities/CuentaMaxLimites';
import {AppInstance} from '../../bussines/entities/AppInstance';
import {DatabaseMetadata} from '../../bussines/entities/DatabaseMetadata';

function useDatabaseMetadata(
   app: Aplicacion | null,
   diasAdicionalesDespuesExpiracion: number = 30
) {
   const dispatch = useDispatch();
   const {openMsgModal} = hooks.useOpenModalStore(dispatch);
   const [estadoMsg, setEstadoMsg] = useState<string | null>(null);

   //@ts-ignore
   const [getDbs, {data: dbList}] = hooks.useApolloLazyQ(getDatabasesAppListGql, {
      callbackError: openMsgModal
   });
   //@ts-ignore
   const [getAppInstancesManager, {data: dbAppInstances}] = hooks.useApolloLazyQ(
      getNanagerInstanciasGql,
      {
         callbackError: openMsgModal
      }
   );
   //@ts-ignore
   const {data: ctaList} = hooks.useApolloQ(getCuentasMaxLimitesGql, {
      callbackError: openMsgModal
   });

   useEffect(() => {
      reloadDatabaseMetadata();
   }, [app]);

   const [databasesMetadata, setDatabasesMetadata] = useState<DatabaseMetadata[]>([]);
   const getDatabaseMetadata = async (
      dbNameList: string[],
      appInstances: AppInstance[],
      cuentaList: CuentaMaxLimites[]
   ) => {
      if (app && app.id && dbNameList && appInstances && cuentaList) {
         setEstadoMsg('Procesando datos...');
         const procesarDatabasesInfo = new ProcesarDatabasesInfoUseCase();
         const newDatabasesMetadataRecurso = await procesarDatabasesInfo.call({
            appId: app!.id,
            appInstances: appInstances,
            ctaList: cuentaList,
            dbList: dbNameList,
            diasAdicionalesDespuesExpiracion
         });
         if (newDatabasesMetadataRecurso.error) {
            openMsgModal(newDatabasesMetadataRecurso.error.toString());
         }
         setEstadoMsg(null);
         if (newDatabasesMetadataRecurso.data) {
            setDatabasesMetadata(newDatabasesMetadataRecurso.data);
         }
      }
   };

   useEffect(() => {
      getDatabaseMetadata(
         dbList?.databasesAppList,
         dbAppInstances?.managerInstancias,
         ctaList?.cuentasMaxlimites
      );
   }, [dbList, dbAppInstances, ctaList, diasAdicionalesDespuesExpiracion]);

   function reloadDatabaseMetadata() {
      if (app && app.id) {
         setEstadoMsg('Cargando bases de datos e informacion en manager...');
         const variables = {app: app.id};
         //@ts-ignore
         getDbs({variables});
         //@ts-ignore
         getAppInstancesManager({variables});
      } else {
         setDatabasesMetadata([]);
      }
   }

   return {
      databasesMetadata,
      estadoMsg,
      reloadDatabaseMetadata
   };
}

export default useDatabaseMetadata;
